import PageHandler from "./PageHandler";
import Pages from "Pages";

class UsersListPageHandler extends PageHandler {
  constructor() {
    super("users-list", Pages.UsersListPage);
  }

  fetch(parameters) {
    this.rootStore.data.UsersStore.fetchByCustomerId(parameters.customerId);

    // If customer not yet loaded, load it!
    let cust = this.rootStore.data.CustomersStore.findById(
      parameters.customerId
    );
    if (!cust) {
      this.rootStore.data.CustomersStore.fetchId(parameters.customerId);
    }
  }
}

export default UsersListPageHandler;



// WEBPACK FOOTER //
// ./src/Stores/UIStore/PageHandlers/UsersListPageHandler.js